import { Component, OnInit, Output, EventEmitter, ElementRef, ViewChild, ChangeDetectorRef } from '@angular/core';
import { FormGroup, FormControl, Validators, FormBuilder} from '@angular/forms';
import { EncryptionService } from 'src/app/middleware/encryption/encryption.service';
import { ReusableClasses } from 'src/app/middleware/common/reusableclassesAndFunctions/reusable-classes';
import { ToastrService } from 'ngx-toastr';
import { StatusConstant } from 'src/app/middleware/common/status/status-constant';
import { LoaderService } from 'src/app/middleware/shared/loader/loader.service';
import * as jwt_decode from 'jwt-decode';
import { CoreService } from '../../../services/coreService/core.service';
import { CoreVm, AddCoreVm, FileModelVM} from 'src/app/viewModels/core/core-vm';
import { Router } from '@angular/router';
import { DataSharingService } from 'src/app/middleware/common/resuableServices/data-sharing.service';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { MatAutocompleteSelectedEvent, MatAutocomplete } from '@angular/material/autocomplete';
import { MatChipInputEvent } from '@angular/material/chips';
import { Observable, Subscription } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { SettingService } from 'src/app/applicationModules/settings/services/settingService/setting.service';
import { ModuleName } from '../../../services/coreService/core.enum';


@Component({
  selector: 'app-add-listing',
  templateUrl: './add-listing.component.html',
  styleUrls: ['./add-listing.component.scss'],
})
export class AddListingComponent implements OnInit {
  addressValue:any;
  cityValue: any;
  stateValue: any;
  zipValue: any;
  grpToggle: boolean = true;
  close: boolean = false;
  checkboxStatus: boolean = false;
  organizationId: string;
  databaseId: string;
  currentUser: any;
  responseHolder: any;
  coreFieldList: any;
  coreFieldListForType: any;
  coreFieldSaveCompare: any;
  coreFieldSaveCompareForType: any;
  coreFieldListSubmit: any;
  myFormGroup: FormGroup;
  addressFormGroup: any=[];
  dynamicArray: any;
  dynamicArrayPhone: any;
  dynamicArrayAddress: any;
  dynamicArrayWebsite: any;
  ImageUploadURL: any = '';
  imagelist: any;
  dropdownlist: any=[]=[];
  dropdownlistType: any;
  newdropdownlist: any;

  multipleDropdownList: any;
  newmultipleDropdownList: any;

  checkBoxList: any;
  newcheckBoxList: any;
 
  chkStatusArry: any;
  imageSrc: string;
  FileName: any;
  FileExtention: any;
  Base64String: any;
  @Output() closeAdd = new EventEmitter<boolean>();
  tempValue: any;
  TypeList: any = [];
  step = 0;


  AllTypeList: any = [];
  selectedTypeList: any;

  fieldsList: any[] = [];
  selectedTypefieldsList: any[] = [];
  getSubFolderFieldsListResponseHolder: any;
  getTagListResponseHolder: any;
  getSubFolderFieldsModel = {
    databaseID: 0,
    userID: "",
    folderID: 0,
    organizationID: 0,
    subFolderID: 0,
    fieldID: 0
  };
  getTagListModel = {
    tagName: "",
    fieldID: 0,
    databaseID: 0,
    organizationID: 0,
    PageSize:0,
    OfficeIDList:[],
    officeID:0
  };
  CityModel = {
    Name: '',
    databaseID: 0,
    userID:''
  };
  ZipModel = {
    ZipCodeValue: '',
    databaseID: 0,
    userID:''
  };
  showAdditionalField: boolean = false;
  expandAdditionalField: boolean = false;
  typeId: number = 0;
  TypeListForDropDown: any = [];


  visible = true;
  selectable = true;
  removable = true;
  separatorKeysCodes: number[] = [ENTER, COMMA];
  
  cityOption: string[]=[];
  filteredOptions: Observable<string[]>;
  fruitCtrl = new FormControl();
  filteredFruits: Observable<string[]>;

  tags: string[] = [];
  allTags: string[] = [];

  @ViewChild('fruitInput') fruitInput: ElementRef<HTMLInputElement>;
  @ViewChild('auto') matAutocomplete: MatAutocomplete;

  clickEventsubscription: Subscription;
  arryaControlNameIdpare: any=[];
  tagvalues: string;
  zipOption: any[];
  stateList: any[];

  permissionAsssign: any[] = [];
  folderListPermission: any[] = [];
  folderList: any[] = [];
  folderID:any;
  OfficeIDList: any=[];
  myOfficeID: any;
  ModuleName:string="";
  spinner:boolean=false;

  constructor(private formBuilder: FormBuilder, private coreService: CoreService,
    private encryptionAlgo: EncryptionService, private reusableClass: ReusableClasses,
    private statusConst: StatusConstant, private loaderService: LoaderService,
    private toastr: ToastrService, private addCoreVm: AddCoreVm, private router: Router,
    private _dataSharingService: DataSharingService, private fileModelVM: FileModelVM,
    private settingsService: SettingService,private cdr: ChangeDetectorRef) {
    const encryptedtoken = sessionStorage.getItem('userToken');
    this.databaseId = sessionStorage.getItem('databaseId');
    this.organizationId = sessionStorage.getItem('organizationID');
    const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);
    this.currentUser = jwt_decode(token);
    var offices=JSON.parse(sessionStorage.getItem('officeList'));
    offices.forEach(oe => {
    this.OfficeIDList.push(oe.officeID);
    if(oe.isMyoffice==true)
      this.myOfficeID=oe.officeID;
    });
    this.filteredFruits = this.fruitCtrl.valueChanges.pipe(startWith(null),map((fruit: string | null) => fruit ? this._filter(fruit) : this.allTags.slice()));
  }

  ngOnDestroy() {
    this.clickEventsubscription.unsubscribe();      
  }
  
  ngOnInit(): void {
    this.clickEventsubscription = this._dataSharingService.getAddListEvent().subscribe(() => {
      this.loaderService.hide();
      this.getAllTagsList();
    });    
   
    var menuModulesList = JSON.parse(sessionStorage.getItem("menuModules"));
    var Module=[];
    Module = menuModulesList.filter(x => x.mainModuleName == ModuleName.Core);
    if(Module.length>0){
      this.ModuleName= Module[0].orgModuleName;
      this.folderID = Module[0].folderID;
     }  

    const phoneNumberregex: RegExp = /(\(?[0-9]{3}\)?-?\s?[0-9]{3}-?[0-9]{4})/;
    this.coreFieldSaveCompareForType = [];
    this.coreFieldListForType=[];
    this.dynamicArray = [];
    this.dynamicArrayPhone = [];
    this.dynamicArrayAddress = [];
    this.dynamicArrayWebsite = [];
    this.getAllFolderFields();
    this.getAllTagsList();
    let group = {};
    this.myFormGroup = new FormGroup(group);
    this.getStateDropdownList(231);
  }

  CheckName(val){
    if(val.trim()=="" || val.trim()==undefined || val.trim()==null || val.trim()=="-" ){
      this.myFormGroup.controls['Name'].setErrors({'incorrect': true}); 
      return;
    } 
    if (val.toLowerCase() != val.toLowerCase().match('^[a-z0-9_%+-]+@[a-z0-9-]+\\[a-z]{2,4}$')&& val.indexOf('@') == -1){     
     }else{
      this.myFormGroup.controls['Name'].setErrors({'incorrect': true});    
     }
  }

  // Used to make Collapsible Panel for group fields
  setStep(index: number) {
    this.step = index;
  }

  nextStep() {
    this.step++;
  }

  prevStep() {
    this.step--;
  }

  add(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value.toLowerCase();
    this.allTags;
    var check=[];
    check= this.allTags.filter(tag => tag.toLowerCase().indexOf(value.trim()) === 0);
    if(check.length>0){
     this.fruitCtrl.setValue(null);
     return;
    }   
    // Add our tag
    if ((value || '').trim()) {
      var arrToUp = String.prototype.toLowerCase.apply(this.tags).split(",");
      const index = arrToUp.indexOf(value.trim());
      if (index >= 0) {
      }
      else {
        this.tags.push(event.value.trim());
      }
    }
    // Reset the input value
    if (input) {
      input.value = '';
    }

    this.fruitCtrl.setValue(null);
  }

  remove(fruit: string): void {
    const index = this.tags.indexOf(fruit);

    if (index >= 0) {
      this.tags.splice(index, 1);
    }
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    this.tags =  this.tags.map(function (el) {
      return el.trim();
    });
    const index = this.tags.indexOf(event.option.viewValue);

    if (index >= 0) {
      this.fruitInput.nativeElement.value = '';    
    }
    else {
      this.tags.push(event.option.viewValue);
      this.fruitInput.nativeElement.value = '';
      this.fruitCtrl.setValue(null);
    }
  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.allTags.filter(fruit => fruit.toLowerCase().indexOf(filterValue) === 0);
  }

  // get Tag List
  getAllTagsList() {
    this.getTagListModel.databaseID = Number(this.databaseId);
    this.getTagListModel.organizationID = Number(this.organizationId);
    this.getTagListModel.tagName = '';    
    this.getTagListModel.PageSize = 0;
    this.getTagListModel.officeID=this.myOfficeID;
	  this.getTagListModel.OfficeIDList=this.OfficeIDList;
    this.settingsService.getAllTagsList(this.getTagListModel).subscribe(response => {
      if (response != undefined) {
        this.getTagListResponseHolder = response;
        if (this.getTagListResponseHolder.status == this.statusConst.statusSuccess) {
          this.allTags = this.getTagListResponseHolder.data.tagNames;         
        }
        else {
  
        }
      }
    });
  }

  states: string[] = [
    'Alabama', 'Alaska', 'Arizona', 'Arkansas', 'California', 'Colorado', 'Connecticut', 'Delaware',
    'Florida', 'Georgia', 'Hawaii', 'Idaho', 'Illinois', 'Indiana', 'Iowa', 'Kansas', 'Kentucky',
    'Louisiana', 'Maine', 'Maryland', 'Massachusetts', 'Michigan', 'Minnesota', 'Mississippi',
    'Missouri', 'Montana', 'Nebraska', 'Nevada', 'New Hampshire', 'New Jersey', 'New Mexico',
    'New York', 'North Carolina', 'North Dakota', 'Ohio', 'Oklahoma', 'Oregon', 'Pennsylvania',
    'Rhode Island', 'South Carolina', 'South Dakota', 'Tennessee', 'Texas', 'Utah', 'Vermont',
    'Virginia', 'Washington', 'West Virginia', 'Wisconsin', 'Wyoming'
  ];

  searchZip(zip :any){
    this.ZipModel.databaseID = Number(this.databaseId);
    this.ZipModel.ZipCodeValue = zip;
    this.ZipModel.userID = this.currentUser.UID;
    this.coreService.searchTransZip(this.ZipModel).subscribe(response => {
      if (response != undefined) {
        if (response.status == this.statusConst.statusSuccess) {     
          this.zipOption=[];
          response.data.forEach(element => {
            this.zipOption.push(element.zipCodeValue);
          });
        }
        else {
        }
      }
    });
  }

  searchCity(name :any){ 
    this.CityModel.databaseID = Number(this.databaseId);
    this.CityModel.Name = name;
    this.CityModel.userID = this.currentUser.UID;
    this.coreService.searchTransCities(this.CityModel).subscribe(response => {
      if (response != undefined) {
        if (response.status == this.statusConst.statusSuccess) {          
          this.cityOption=[];
          response.data.forEach(element => {
            this.cityOption.push(element.name);
          });
        }
        else {
        }
      }
    });
  }

  getStateDropdownList(countryId:any) {
    if (countryId!=undefined) {
      this.coreService.getStateList(countryId).subscribe(response => {
          if (response!=undefined) {
            if (response.status == this.statusConst.statusSuccess) {
              this.stateList = [];
              if(countryId == 231 || countryId == 38){              
                response.data  =  response.data.filter((x) => x.abbreviation != null);
                response.data.forEach(e => {
                  this.stateList.push(e.abbreviation);
                });
              }else{
                response.data.forEach(e => {
                  this.stateList.push(e.stateName);
                });
              }             
            }
          }
        });
    }
  }

  numberOnly(event): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  addMore(fieldName: any) {
    if (fieldName == 'Email') {
      let length = this.dynamicArray.length;
      length = length + 1;

      this.myFormGroup.addControl(
        fieldName + length,
        this.formBuilder.control('')
      );
      this.myFormGroup.addControl(
        fieldName + length + 'option',
        this.formBuilder.control('')
      );

      this.coreFieldSaveCompare.forEach((formControl) => {
        if (formControl.fieldName == 'Email') {
          this.dynamicArray.push(formControl);
        }
      });
    }
    // Phone
    if (fieldName == 'Phone') {
      let length = this.dynamicArrayPhone.length;
      length = length + 1;

      this.myFormGroup.addControl(
        fieldName + length,
        this.formBuilder.control('')
      );
      this.myFormGroup.addControl(
        fieldName + length + 'option',
        this.formBuilder.control('')
      );

      this.coreFieldSaveCompare.forEach((formControl) => {
        if (formControl.fieldName == 'Phone') {
          this.dynamicArrayPhone.push(formControl);
        }
      });
    }
    //Address
    if (fieldName == 'Address') {
      let length = this.dynamicArrayAddress.length;
      length = length + 1;

      this.myFormGroup.addControl(fieldName + length,this.formBuilder.control(''));      

      this.myFormGroup.addControl(fieldName + length + 'option', this.formBuilder.control(''));

      //
      this.myFormGroup.addControl('City' + length, this.formBuilder.control(''));
      this.myFormGroup.addControl('State' + length, this.formBuilder.control(''));
      this.myFormGroup.addControl('ZipCode' + length,this.formBuilder.control(''));
      this.myFormGroup.addControl('Country' + length,this.formBuilder.control(''));
      //

      this.coreFieldSaveCompare.forEach((formControl) => {
        if (formControl.fieldName == 'Address') {
          this.dynamicArrayAddress.push(formControl);
        }
      });
    }
    //Website
    if (fieldName == 'WebSite') {
      let length = this.dynamicArrayWebsite.length;
      length = length + 1;

      this.myFormGroup.addControl(
        fieldName + length,
        this.formBuilder.control('')
      );
      this.myFormGroup.addControl(
        fieldName + length + 'option',
        this.formBuilder.control('')
      );

      this.coreFieldSaveCompare.forEach((formControl) => {
        if (formControl.fieldName == 'WebSite') {
          this.dynamicArrayWebsite.push(formControl);
        }
      });
    }
  }

  clearPlaceholder(event: any) {
    event.source.placeholder = '';
  }


  // get all created Feilds
  getAllFolderFields() {
    const phoneNumberregex: RegExp = /(\(?[0-9]{3}\)?-?\s?[0-9]{3}-?[0-9]{4})/;
    var reqModel={
      userID : this.currentUser.UID,
	    organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),     
      folderID : this.folderID,//17;
      subFolderID: 0,
      fieldID: 0,
      requestFrom: 0,
      officeID:this.myOfficeID,
	    OfficeIDList:this.OfficeIDList
    }   
    this.loaderService.show();
    this.coreService.getCoreFeildList(reqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.coreFieldSaveCompare = response.data.activeFields.filter((m) => m.fieldID > 0);

          this.coreFieldSaveCompareForType = response.data.activeFields.filter((m) => m.fieldID > 0);

          this.coreFieldList = response.data.activeFields;
          this.AllTypeList = response.data.types;
          this.AllTypeList.splice(0,0,{folderName: "Select", isChecked: false,subFolderID: 0});
         
          var NewList;
          NewList = response.data.activeFields.filter((s) => s.fieldName != 'Type');
          var type;
          type = this.coreFieldList.filter((s) => s.fieldTypeName == 'Dropdown' && s.fieldName == 'Type');
          NewList.splice(1, 0, type[0]);
          this.coreFieldList = NewList;

          this.imagelist = this.coreFieldList.filter((e) => e.fieldTypeName == 'Image');
          this.coreFieldList = this.coreFieldList.filter((s) => s.fieldTypeName != 'Image');
          this.coreFieldList = this.coreFieldList.filter((s) => s.isActive == true );
          this.coreFieldList = this.coreFieldList.filter((s) => s.availableOn != 2); 
          this.coreFieldList = this.coreFieldList.filter((s) => s.rolePermission != 2); 
        
          this.coreFieldListForType = this.coreFieldList;

          const Fields = {};
          this.coreFieldList.forEach((formControl) => {
            if (formControl.fieldID == 0 && formControl.data.length > 0) {
              formControl.data.forEach((ctrlgrp,) => {
                if (ctrlgrp.fieldID > 0) {
                  this.coreFieldSaveCompare.push(ctrlgrp);
                  if (ctrlgrp.fieldName == 'Phone')
                    Fields[ctrlgrp.fieldName] = new FormControl(
                      '',
                      Validators.pattern(phoneNumberregex)
                    );
                  else
                  {
                    Fields[ctrlgrp.fieldName] = new FormControl('');
                  }
                  if (ctrlgrp.fieldNames.length > 0) {
                    const toSelect = ctrlgrp.fieldNames[0];
                    this.tempValue = toSelect;
                    Fields[ctrlgrp.fieldName + 'option'] = new FormControl();
                  }
                }
              });
            }
            else {
              if (formControl.fieldName == 'Phone')
                Fields[formControl.fieldName] = new FormControl(
                  '',
                  Validators.pattern(phoneNumberregex)
                );
              else Fields[formControl.fieldName] = new FormControl('');

              if (formControl.fieldNames.length > 0) {
                const toSelect = formControl.fieldNames[0];
                this.tempValue = toSelect;
                Fields[formControl.fieldName + 'option'] = new FormControl();
              }
            }
          });
          ///
          Fields['City'] = new FormControl();
          Fields['State'] = new FormControl();
          Fields['ZipCode'] = new FormControl();
          Fields['Country'] = new FormControl();
            // address computaion array for computation
         this.addressFormGroup.push('Address');
         this.addressFormGroup.push('City');
         this.addressFormGroup.push('State');
         this.addressFormGroup.push('ZipCode');
         this.addressFormGroup.push('Country');
         //
          ///
          this.myFormGroup = new FormGroup(Fields);

         // Check for Without Group //
          this.dropdownlist = this.coreFieldList.filter((s) => s.fieldTypeName == 'Dropdown' && s.fieldName != 'Type');
          this.multipleDropdownList = this.coreFieldList.filter((s) => s.fieldTypeName == 'MultiSelect');
          this.checkBoxList = this.coreFieldList.filter((s) => s.fieldTypeName == 'Checkbox');

          var data = [];

          data=this.coreFieldList.filter((s) => s.fieldID ==0);

          if (data.length > 0) {
            for (var i = 0, len = data.length; i < len; ++i) {
              var DrpData = [];
              DrpData = data[i].data.filter((s)=> s.fieldTypeName == 'Dropdown');
              if(DrpData.length>0){
                for (var v = 0, char = DrpData.length; v < char; ++v) {
                  this.dropdownlist.push(DrpData[v]);
                }
              }
             
              var MultiData=[];
              MultiData = data[i].data.filter((s)=> s.fieldTypeName == 'MultiSelect');
              if(MultiData.length>0){
                for (var v = 0, char = MultiData.length; v < char; ++v) {
                  this.multipleDropdownList.push(MultiData[v]);
                }
              }
              
              var CheckboxData=[];
              CheckboxData = data[i].data.filter((s)=> s.fieldTypeName == 'Checkbox');
              if(CheckboxData.length>0){
                for (var v = 0, char = CheckboxData.length; v < char; ++v) {
                  this.checkBoxList.push(CheckboxData[v]);
                }
              }             
            }
          }               
         
          if (this.dropdownlist.length > 0) {
            var fieldListdrp = [];
            var value;
            for (let i = 0; i < this.dropdownlist.length; i++) {
              var dropValue = this.dropdownlist[i].defaultValue.replace(/,\s*$/, "");
              value = dropValue.split(',');          
              var FieldsDrp = {
                FieldValue: this.dropdownlist[i].fieldName,
                value: value,
              };
              fieldListdrp.push(FieldsDrp);
            }
            this.dropdownlist = fieldListdrp;
          }

          if (this.multipleDropdownList.length > 0) {
            var fieldmulListdrp = [];
            var value;
            for (let i = 0; i < this.multipleDropdownList.length; i++) {
              var multidropValue = this.multipleDropdownList[i].defaultValue.replace(/,\s*$/, "");
              value = multidropValue.split(',');
             
              var FieldsMulDrp = {
                FieldValue: this.multipleDropdownList[i].fieldName,
                value: value,
              };
              fieldmulListdrp.push(FieldsMulDrp);
            }
            this.multipleDropdownList = fieldmulListdrp;
          }

          if (this.checkBoxList.length > 0) {
            var fieldcheckbox = [];
            var value;
            for (let i = 0; i < this.checkBoxList.length; i++) {
              var checkboxValue = this.checkBoxList[i].defaultValue.replace(/,\s*$/, "");
              value = checkboxValue.split(',');
              var FieldsCheckbox = {
                FieldValue: this.checkBoxList[i].fieldName,
                value: value,
              };
              fieldcheckbox.push(FieldsCheckbox);
            }
            this.checkBoxList = fieldcheckbox;
          }         
        }else{
          this.loaderService.hide();
        }
      }else{
        this.loaderService.hide();
      }
    });
  }
  
  getSubFolderFields(event, fieldName) {
    if (event != undefined && fieldName == "Type") {     
      var reqModel={
        userID : this.currentUser.UID,      
        organizationID: Number(this.organizationId),
        databaseID: Number(this.databaseId), 
        FolderId : this.folderID,//17;
        subFolderID: 0,
        fieldID: 0,
        requestFrom: 0,
        officeID:this.myOfficeID,
        OfficeIDList:this.OfficeIDList
      }        
      this.coreService.getCoreFeildList(reqModel).subscribe((response) => {
        if (response != undefined) {
          this.responseHolder = response;
          if (this.responseHolder.status == this.statusConst.statusSuccess) {
            this.coreFieldSaveCompareForType = response.data.activeFields.filter((m) => m.fieldID > 0 );
          }

          this.coreFieldListForType = response.data.activeFields.filter((s) => s.fieldTypeName != 'Image');

          var NewList;
          NewList = response.data.activeFields.filter((s) => s.fieldName != 'Type');
          var type;
          type = this.coreFieldListForType.filter((s) => s.fieldTypeName == 'Dropdown' && s.fieldName == 'Type');

          NewList.splice(1, 0, type[0]);          
          this.coreFieldListForType = NewList;

          this.coreFieldListForType = this.coreFieldListForType.filter((s) => s.fieldTypeName != 'Image');
          this.coreFieldListForType = this.coreFieldListForType.filter((s) => s.isActive == true);         
        }
        this.getTypeFieldList(event);
      });
  
    }
  }

  getTypeFieldList(event){
    const phoneNumberregex: RegExp = /(\(?[0-9]{3}\)?-?\s?[0-9]{3}-?[0-9]{4})/;
    this.typeId = event.value;
    var ReqModel={
      userID : this.currentUser.UID,      
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),    
      folderID : this.folderID,//17;
      subFolderID: this.typeId,
      fieldID: 0,
      requestFrom: 0,
      officeID:this.myOfficeID,
	    OfficeIDList:this.OfficeIDList
    }   
    this.settingsService.getAllFieldsCore(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.getSubFolderFieldsListResponseHolder = response;
        if (this.getSubFolderFieldsListResponseHolder.status == this.statusConst.statusSuccess) {
          this.fieldsList = this.getSubFolderFieldsListResponseHolder.data.activeFields.filter(s => s.fieldTypeName != 'Image');
                   
          this.AllTypeList = this.getSubFolderFieldsListResponseHolder.data.types;
          this.AllTypeList.splice(0,0,{folderName: "Select", isChecked: false,subFolderID: 0});
          

          this.coreFieldListForType = this.getSubFolderFieldsListResponseHolder.data.activeFields.filter((s) => s.fieldTypeName != 'Image');
        
          this.coreFieldListForType =this.fieldsList;
          this.coreFieldSaveCompare = this.coreFieldSaveCompareForType;
         // this.coreFieldList = this.coreFieldListForType;

          var NewList;
          NewList = this.getSubFolderFieldsListResponseHolder.data.activeFields.filter((s) => s.fieldName != 'Type');
          var type;
          type = this.coreFieldListForType.filter((s) => s.fieldTypeName == 'Dropdown' && s.fieldName == 'Type');

          NewList.splice(1, 0, type[0]);          
          this.coreFieldListForType = NewList;

          this.coreFieldListForType = this.coreFieldListForType.filter((s) => s.fieldTypeName != 'Image');
          this.coreFieldListForType = this.coreFieldListForType.filter((s) => s.isActive == true);  
       

          this.selectedTypefieldsList = this.fieldsList.filter(({ fieldID: id1 }) => !this.coreFieldList.some(({ fieldID: id2 }) => id2 === id1));
          this.selectedTypefieldsList = this.selectedTypefieldsList.filter((s) => s.fieldID > 0);

          var tempArryacoreFieldList=[];
          tempArryacoreFieldList=this.getSubFolderFieldsListResponseHolder.data.activeFields.filter((m) => m.fieldID == 0);

          if(tempArryacoreFieldList.length>0){
           var check= this.coreFieldList.filter(({ position: id1 }) => !this.fieldsList.some(({ position: id2 }) => id2 === id1));
           if(check.length==0){
             tempArryacoreFieldList=[];
            }
          }
          
          this.dropdownlist = this.fieldsList.filter((s) => s.fieldTypeName == 'Dropdown' && s.fieldName != 'Type');
          this.multipleDropdownList = this.fieldsList.filter((s) => s.fieldTypeName == 'MultiSelect');
          this.checkBoxList = this.fieldsList.filter((s) => s.fieldTypeName == 'Checkbox');

          var data = [];
          this.arryaControlNameIdpare=[];
          data=this.fieldsList.filter((s) => s.fieldID ==0);         

          if (data.length > 0) {
            for (var i = 0, len = data.length; i < len; ++i) {
              var DrpData = [];
              DrpData = data[i].data.filter((s)=> s.fieldTypeName == 'Dropdown');
              if(DrpData.length>0){
                for (var v = 0, char = DrpData.length; v < char; ++v) {
                  this.dropdownlist.push(DrpData[v]);
                }
              }
             
              var MultiData=[];
              MultiData = data[i].data.filter((s)=> s.fieldTypeName == 'MultiSelect');
              if(MultiData.length>0){
                for (var v = 0, char = MultiData.length; v < char; ++v) {
                  this.multipleDropdownList.push(MultiData[v]);
                }
              }
              
              var CheckboxData=[];
              CheckboxData = data[i].data.filter((s)=> s.fieldTypeName == 'Checkbox');
              if(CheckboxData.length>0){
                for (var v = 0, char = CheckboxData.length; v < char; ++v) {
                  this.checkBoxList.push(CheckboxData[v]);
                }
              }             
            }
          }               

            if (this.dropdownlist.length > 0) {
              var fieldListdrp = [];
              var value;
              for (let i = 0; i < this.dropdownlist.length; i++) {

                var drpValue = this.dropdownlist[i].defaultValue.replace(/,\s*$/, "");
                value = drpValue.split(',');
                var FieldsDrp = {
                  FieldValue: this.dropdownlist[i].fieldName,
                  value: value,
                };
                fieldListdrp.push(FieldsDrp);
              }
              this.dropdownlist = fieldListdrp;
            }

            if (this.multipleDropdownList.length > 0) {
              var fieldmulListdrp = [];
              var value;
              for (let i = 0; i < this.multipleDropdownList.length; i++) {
                var muldrpValue = this.multipleDropdownList[i].defaultValue.replace(/,\s*$/, "");
                value = muldrpValue.split(',');
                var FieldsMulDrp = {
                  FieldValue: this.multipleDropdownList[i].fieldName,
                  value: value,
                };
                fieldmulListdrp.push(FieldsMulDrp);
              }
              this.multipleDropdownList = fieldmulListdrp;
            }

            if (this.checkBoxList.length > 0) {
              var fieldcheckbox = [];
              var value;
              for (let i = 0; i < this.checkBoxList.length; i++) {
                var checkboxValue = this.checkBoxList[i].defaultValue.replace(/,\s*$/, "");
                value = checkboxValue.split(',');
                var FieldsCheckbox = {
                  FieldValue: this.checkBoxList[i].fieldName,
                  value: value,
                };
                fieldcheckbox.push(FieldsCheckbox);
              }
              this.checkBoxList = fieldcheckbox;
            }   
           

            
             // Modified array containing group starts
             tempArryacoreFieldList.forEach(element => {
              if(element.data.length>1) {
                var indexArray=[];              
                element.data.forEach(elementin => {
                  if(elementin.fieldID>0)
                  {
                    let grpele=this.coreFieldList.find(x=>x.fieldName==elementin.fieldName && x.fieldID==elementin.fieldID);
                    elementin.fieldValue=grpele!=undefined?grpele.fieldValue:"";
                    elementin.id=grpele!=undefined?grpele.id:0;
                    elementin.isRequired=grpele!=undefined?grpele.isRequired:false;
                    if(elementin.fieldNames.length>0)
                    {
                      if(grpele!=undefined){
                        elementin.fieldNameID=grpele.fieldNameID;
                        elementin.placeholderVal=grpele.placeholderVal; 
                      }                                          
                    }
                    this.coreFieldList.push(elementin);
                    if (!this.myFormGroup.contains(elementin.fieldName))
                    {
                      this.myFormGroup.addControl(elementin.fieldName, this.formBuilder.control(''));
                    }
                    var index = this.coreFieldList.findIndex(x=>x.fieldName==elementin.fieldName && x.fieldID==elementin.fieldID);
                    indexArray.push(index);
                  }
                });                 
               
                this.coreFieldList = this.coreFieldList.filter(function(value, index) { 
                  return indexArray.indexOf(index) == -1; 
              }) ;
                this.coreFieldList.splice(indexArray[0],0,element);                
              }
            });
          

          if (this.selectedTypefieldsList.length == 0) {
            this.coreFieldSaveCompare = this.coreFieldSaveCompareForType;
            this.coreFieldList = this.coreFieldListForType;
            
             this.coreFieldList = this.coreFieldList.filter((s) => s.availableOn != 2);
             this.coreFieldList = this.coreFieldList.filter((s) => s.rolePermission != 2); 

            const Fields = {};           
            this.coreFieldList.forEach((formControl) => {
              if (formControl.fieldID == 0 && formControl.data.length > 0) {
                formControl.data.forEach((ctrlgrp,) => {
                
                  if (ctrlgrp.fieldID > 0) {
                    this.coreFieldSaveCompare.push(ctrlgrp);
                    if (ctrlgrp.fieldName == 'Phone')
                      Fields[ctrlgrp.fieldName] = new FormControl(
                        '',
                        Validators.pattern(phoneNumberregex)
                      );
                    else
                      Fields[ctrlgrp.fieldName] = new FormControl('');

                    if (ctrlgrp.fieldNames.length > 0) {
                      const toSelect = ctrlgrp.fieldNames[0];
                      this.tempValue = toSelect;
                      Fields[ctrlgrp.fieldName + 'option'] = new FormControl();
                    }
                  }
                });
              }
              else {
                if (formControl.fieldName == 'Phone')
                  Fields[formControl.fieldName] = new FormControl(
                    '',
                    Validators.pattern(phoneNumberregex)
                  );
                else Fields[formControl.fieldName] = new FormControl('');

                if (formControl.fieldNames.length > 0) {
                  const toSelect = formControl.fieldNames[0];
                  this.tempValue = toSelect;
                  Fields[formControl.fieldName + 'option'] = new FormControl();
                }
              }
            });
         
          }
           
          this.arryaControlNameIdpare=[];

            if (this.selectedTypefieldsList.length > 0) {
            for (let i = 0; i < this.selectedTypefieldsList.length; i++) {
              this.coreFieldSaveCompare.push(this.selectedTypefieldsList[i]);            
              this.arryaControlNameIdpare.push({
                name:this.selectedTypefieldsList[i].fieldName,
                id:this.selectedTypefieldsList[i].id,
                subfolderID:this.selectedTypefieldsList[i].subfolderID
              });
              var index = this.fieldsList.findIndex(x=>x.fieldName==this.selectedTypefieldsList[i].fieldName && x.fieldID==this.selectedTypefieldsList[i].fieldID);
              this.coreFieldList.splice(index,0,this.selectedTypefieldsList[i]);
            }                           

            this.selectedTypefieldsList.forEach((formControl) => {
              this.myFormGroup.addControl(formControl.fieldName, this.formBuilder.control(''));
            });

            this.coreFieldList = this.coreFieldListForType;
            
            this.coreFieldList = this.coreFieldList.filter((s) => s.availableOn != 2);
            this.coreFieldList = this.coreFieldList.filter((s) => s.rolePermission != 2);
          

            const Fields = {};         
            this.coreFieldList.forEach((formControl) => {
              if (formControl.fieldID == 0 && formControl.data.length > 0) {
                formControl.data.forEach((ctrlgrp,) => {
                  if (ctrlgrp.fieldID > 0) {
                    this.coreFieldSaveCompare.push(ctrlgrp);
                    if (ctrlgrp.fieldName == 'Phone')
                      Fields[ctrlgrp.fieldName] = new FormControl('', Validators.pattern(phoneNumberregex));
                    else
                      Fields[ctrlgrp.fieldName] = new FormControl('');

                    if (ctrlgrp.fieldNames.length > 0) {
                      const toSelect = ctrlgrp.fieldNames[0];
                      this.tempValue = toSelect;
                      Fields[ctrlgrp.fieldName + 'option'] = new FormControl();
                    }
                  }
                });
              }
              else {
                if (formControl.fieldName == 'Phone')
                  Fields[formControl.fieldName] = new FormControl('',Validators.pattern(phoneNumberregex));
                else Fields[formControl.fieldName] = new FormControl('');

                if (formControl.fieldNames.length > 0) {
                  const toSelect = formControl.fieldNames[0];
                  this.tempValue = toSelect;
                  Fields[formControl.fieldName + 'option'] = new FormControl();
                }
              }
            }); 
         
          }
          else {
          }
        }
      }
    });
    
  }

  getdropdownlist(fieldName) {
    var _newdropdownlist = this.dropdownlist.filter((s) => s.FieldValue == fieldName);
    return _newdropdownlist[0].value;
  }

  getMuldropdownlist(fieldName) {
    var _newMuldropdownlist = this.multipleDropdownList.filter((s) => s.FieldValue == fieldName);
    return _newMuldropdownlist[0].value;
  }

  
  getCheckBoxlist(fieldName) {
    var _newcheckBoxlist = this.checkBoxList.filter((s) => s.FieldValue == fieldName);
    return _newcheckBoxlist[0].value;
  }

   OnChange($event: any, chk: any, fieldId: any) {
    this.myFormGroup.get(chk).markAsDirty();
    if (!this.chkStatusArry) {
      this.chkStatusArry = [];
    }
    if ($event.checked) {     
      if(this.chkStatusArry.length>0){
       var checkRecord=[];
       checkRecord = this.chkStatusArry.filter(x=>x.fieldId==fieldId);
       if(checkRecord.length>0){
       this.chkStatusArry.find((item) => item.fieldId == fieldId).ckh = chk;
       }
      }else{
       this.chkStatusArry.push({
        ckh: chk,
        fieldId: fieldId,
       });
      }    
    } else {
      if(this.chkStatusArry.length>0){
        this.chkStatusArry.find((item) => item.fieldId == fieldId).ckh = '';
      } 
      // if (this.chkStatusArry.find((s) => s.fieldId == fieldId && s.ckh == chk)) {
      //   this.chkStatusArry = this.chkStatusArry.filter((item) => item.ckh != chk);
      // }
    }
  }
  // OnChange($event: any, chk: any, fieldId: any) {   
  //   let ckhchecked = [];
  //   if (!this.chkStatusArry) {
  //     this.chkStatusArry = [];
  //   }
  //   if ($event.checked) {
  //     this.chkStatusArry.push({
  //       ckh: chk,
  //       fieldId: fieldId,
  //     });
  //   } else {
  //     if(this.chkStatusArry.find((s) => s.fieldId == fieldId && s.ckh == chk)) {
  //       this.chkStatusArry = this.chkStatusArry.filter(
  //         (item) =>
  //           item.ckh != chk
  //       );
  //     }
  //   }
  // }

  handleInputChange(files) {
    var file = files;
    var pattern = /image-*/;
    var reader = new FileReader();
    if (!file.type.match(pattern)) {
      alert('invalid format');
      return;
    }
    this.FileName = reader.onloadend = this._handleReaderLoaded.bind(this);
    reader.readAsDataURL(file);
  }

  _handleReaderLoaded(e) {
    let reader = e.target;
    var base64result = reader.result.substr(reader.result.indexOf(',') + 1);
    this.imageSrc = base64result;
    this.fileModelVM.UserID = this.currentUser.UID;
    this.fileModelVM.DatabaseID = Number(this.databaseId);
    this.fileModelVM.OrganizationID = Number(this.organizationId);
    this.fileModelVM.Base64String = this.imageSrc;
    this.fileModelVM.FileName = this.FileName;
    this.fileModelVM.FileExtention = this.FileExtention;
    this.coreService.getImageUlpoadURL(this.fileModelVM).subscribe((response) => {
        if (response != undefined) {
          this.responseHolder = response;
          if (this.responseHolder.status == this.statusConst.statusSuccess) {
            this.ImageUploadURL = response.data;
          }
        }
      });
  }

  

  onSubmit(formValues, form) {
    this.spinner=true;
    this.myFormGroup.markAsPristine();

    if (this.myFormGroup.invalid) {
      return;
    }
    if (formValues !== undefined) {
      this.addCoreVm.DatabaseID = Number(this.databaseId);
      this.addCoreVm.UserID = this.currentUser.UID;
      this.addCoreVm.OrganizationID = Number(this.organizationId);
      this.addCoreVm.FolderID = this.folderID;//17;
      var fieldList = [];

      //Todo Send elements in proper order
      for (var key in formValues) {
        var tempList = [];
        if (this.coreFieldSaveCompare.find((m) => m.fieldName == key)) {
          this.coreFieldSaveCompare.forEach((s) => {
            if (s.fieldName == key) {
              if (s.fieldNames.length > 0) {
                s.fieldNameID =
                (formValues[key + 'option'] == undefined || formValues[key + 'option']=='')
                    ? s.fieldNames[0].fieldNameID
                    : Number(formValues[s.fieldName + 'option']);
              }
              tempList.push(s);
            }
          });
        } else {
          let control = this.coreFieldSaveCompare.find((m) =>
            key.includes(m.fieldName)
          );

          if (
            key != 'Addressoption' &&
            key != 'Emailoption' &&
            key != 'Phoneoption' &&
            !key.includes('option')
          ) {
            if (control != undefined) {
              if (control.fieldNames.length > 0) {
                tempList.push({
                  fieldID: Number(control.fieldID),
                  fieldName: key,
                  fieldValue: formValues[key],
                  fieldNameID:
                  (formValues[key + 'option'] == undefined || formValues[key + 'option']=='')
                      ? control.fieldNames[0].fieldNameID
                      : Number(formValues[key + 'option']),
                });
              }
            }

          }
        }
        let selectedValues: any;
        if (tempList.length > 0) {
          if (tempList[0].fieldTypeName == 'Checkbox') {
            if (this.chkStatusArry && this.chkStatusArry.length > 0)
              selectedValues = this.chkStatusArry
                .filter((item) => item.fieldId == tempList[0].fieldID)
                .map((x) => x.ckh)
                .join(',');
          }
          if (tempList[0].fieldTypeName == 'MultiSelect') {
            if (tempList[0].fieldName == 'Tags' && tempList[0].fieldTypeName == 'MultiSelect') {
              if (this.tags.length > 0) {
                selectedValues = this.tags.join(', ');
                this.tagvalues=this.tags.join(', ');
              } else {
                selectedValues = '';
              }
            }
            else {
              if (formValues[key] == null || formValues[key].length === 0) {
                selectedValues = '';
              } else {
                selectedValues = formValues[key].join();
              }
            }

          }
          if (tempList[0].fieldTypeName == 'Dropdown') {
            if (tempList[0].fieldName == 'Type' && tempList[0].fieldTypeName == 'Dropdown') {
              if (this.typeId != undefined) {
                selectedValues = this.typeId.toString();
              } else {
                selectedValues = '';
              }
            }
            else {
              if (formValues[key] == null || formValues[key].length === 0) {
                selectedValues = '';
              } else {
                selectedValues = formValues[key];
              }
            }

          }
          if (tempList[0].fieldTypeName == 'Image') {
            if (formValues[key].length == 0) {
              selectedValues = '';
            } else {
              selectedValues = this.ImageUploadURL; 
            }
          }

          let localDateOnly="";
          if(tempList[0].fieldTypeName=='Date')
          {
            let selectedDate = this.myFormGroup.get(tempList[0].fieldName).value;

            // If selectedDate is a string, set localDateOnly to the string value directly
            if (typeof selectedDate === "string") {
              localDateOnly = selectedDate;
            } else if (selectedDate instanceof Date && !isNaN(selectedDate.getTime())) {
              // Adjust the date to remove time and prevent timezone shift
              localDateOnly = new Date(selectedDate.getTime() - selectedDate.getTimezoneOffset() * 60000)
                .toISOString()
                .split('T')[0]; // Returns 'yyyy-MM-dd'
              formValues[key]= localDateOnly;
            } else {
              localDateOnly = ""; // Set to empty if no valid date
            }

          }

          let frmctrl= this.arryaControlNameIdpare.find(e => e.name== key);
          var Fields = {
            FieldID: tempList[0].fieldID,
            FieldName: key,
            FieldValue:
              tempList[0].fieldTypeName == 'Image' ||
                tempList[0].fieldTypeName == 'Checkbox' ||
                tempList[0].fieldTypeName == 'MultiSelect' ||
                tempList[0].fieldTypeName == 'Dropdown'
                ? selectedValues
                : formValues[key],
            FieldNameID:
              tempList[0].fieldNameID > 0
                ? Number(tempList[0].fieldNameID)
                : null,
                SubFolderID:frmctrl!=undefined? frmctrl.subfolderID:0,
                ChildFields: []
          };

          fieldList.push(Fields);
        }
      }

      this.imagelist.forEach((element) => {
        var FieldsImg = {
          FieldID: element.fieldID,
          FieldName: element.fieldName,
          FieldValue: this.ImageUploadURL,
          FieldNameID: null,
        };
        fieldList.push(FieldsImg);
      });
     
     
      /*************/

      // Country = 1,
      //   State = 2,
      //   City = 3,
      //   Zip = 4,
      
      let indexDefault =fieldList.findIndex(n=>n.FieldName=='Address');
      let AddressDefault=fieldList.find(n=>n.FieldName=='Address');
      AddressDefault.ChildFields.push({
        "id": 0,
        "fieldID": AddressDefault.FieldID,
        "fieldValue": formValues["City"],
        "childFieldType": 3
      })
      AddressDefault.ChildFields.push({
        "id": 0,
        "fieldID": AddressDefault.FieldID,
        "fieldValue": formValues["State"],
        "childFieldType": 2
      })
      AddressDefault.ChildFields.push({
        "id": 0,
        "fieldID": AddressDefault.FieldID,
        "fieldValue": formValues["ZipCode"],
        "childFieldType": 4
      })
      AddressDefault.ChildFields.push({
        "id": 0,
        "fieldID": AddressDefault.FieldID,
        "fieldValue": formValues["Country"],
        "childFieldType": 1
      })
    fieldList = fieldList.filter(function(value, index) { 
        return index != indexDefault; 
    }) ;
    fieldList.splice(indexDefault,0,AddressDefault);
    /************/   
    /***********/
    

      //
      this.dynamicArrayAddress.forEach((element,i) => {
        i=i+1;
        let indexDynamic =fieldList.findIndex(n=>n.FieldName=='Address'+i);
        let AddressDynamic=fieldList.find(n=>n.FieldName=='Address'+i);
        AddressDynamic.ChildFields.push({
          "id": 0,
          "fieldID": AddressDynamic.FieldID,
          "fieldValue": formValues["City"+i],
          "childFieldType": 3
        })
        AddressDynamic.ChildFields.push({
          "id": 0,
          "fieldID": AddressDynamic.FieldID,
          "fieldValue": formValues["State"+i],
          "childFieldType": 2
        })
        AddressDynamic.ChildFields.push({
          "id": 0,
          "fieldID": AddressDynamic.FieldID,
          "fieldValue": formValues["ZipCode"+i],
          "childFieldType": 4
        })
        AddressDynamic.ChildFields.push({
          "id": 0,
          "fieldID": AddressDynamic.FieldID,
          "fieldValue": formValues["Country"+i],
          "childFieldType": 1
        })
      fieldList = fieldList.filter(function(value, index) { 
          return index != indexDynamic; 
      }) ;
      fieldList.splice(indexDynamic,0,AddressDynamic);

      });
      fieldList =fieldList.filter(x=> x.FieldName!="Status");
      //********** */
      this.addCoreVm.ImageUrl=this.ImageUploadURL
      this.addCoreVm.Fields = fieldList;
      this.addCoreVm.Tags=this.tagvalues;
      this.addCoreVm.TypeID=Number(this.typeId)>0?Number(this.typeId):0;
      this.addCoreVm.officeID=this.myOfficeID;
      this.addCoreVm.OfficeIDList=this.OfficeIDList;
      this.addCoreVm.Status=formValues.Status;
      this.loaderService.show();
      //return;
      this.coreService.saveCoreFeildList(this.addCoreVm).subscribe((response) => {
      if (response != undefined) {
            this.responseHolder = response;
            if (this.responseHolder.status == this.statusConst.statusSuccess) {
              this.loaderService.hide();
              this.spinner=false;
              this.closeListing(false);
              this.tags = [];
              this.myFormGroup.reset();            
              this.router.navigate(['/core/listing']);
              this._dataSharingService.sendSaveUserForCore();
              this.toastr.success('Record save successfully.', '', {
                timeOut: 3000,
              });
            }else{
              this.spinner=false;
              this.loaderService.hide();
            }
          }else{
            this.spinner=false;
            this.loaderService.hide();
          }
        });
    }
  }

  onSelectFile(fileInput: any) {
    this.handleInputChange(fileInput.target.files[0]);
    var filename = fileInput.target.files[0].name;
    var test = filename.split('.');
    this.FileName = test[0];
    this.FileExtention = '.' + test[1];
  }

  closeListing(message: boolean) {
    this.ImageUploadURL="";
    //this.getAllFolderFields();
    this.tags = [];
    this.closeAdd.emit(message);
    this.myFormGroup.reset();
  }

   
}
